/* eslint-disable quotes,flowtype/require-valid-file-annotation,indent,no-var,no-unused-expressions,curly */
import {event} from 'd3-selection';

export function nopropagation() {
  event.stopImmediatePropagation();
}

export default function() {
  event.preventDefault();
  event.stopImmediatePropagation();
}



// WEBPACK FOOTER //
// ./web_modules/d3-brush/src/noevent.js